import React from 'react';
import PropTypes from 'prop-types';
import {
  commentsProps,
  viewingAthleteProps
} from '../../../components/Feed/props/feed-prop-types';
import Microfrontend, { getMfeRemoteEntryUrl } from '../../Microfrontend';

const PostsKudosAndComments = ({
  canKudo,
  commentsEnabled,
  comments,
  kudosCount,
  entityId,
  viewingAthlete,
  post,
  authorAvatarUrl,
  authorDisplayName,
  ownedByCurrentAthlete
}) => {
  const appContext = {
    canKudo,
    commentsEnabled,
    comments,
    kudosCount,
    entity: 'post',
    entityId,
    ownerName: authorDisplayName,
    ownerAvatarUrl: authorAvatarUrl,
    ownerAthleteId: post.athlete_id,
    activityName: post.summary,
    ownedByCurrentAthlete,
    viewingAthlete
  };

  return (
    <Microfrontend
      url={getMfeRemoteEntryUrl('adp-social-engagement')}
      scope="strava_adp_social_engagement"
      component="./App"
      appContext={appContext}
    />
  );
};

PostsKudosAndComments.propTypes = {
  canKudo: PropTypes.bool.isRequired,
  comments: commentsProps.isRequired,
  kudosCount: PropTypes.number.isRequired,
  entityId: PropTypes.string.isRequired,
  commentsEnabled: PropTypes.bool.isRequired,
  viewingAthlete: viewingAthleteProps.isRequired,
  ownedByCurrentAthlete: PropTypes.bool.isRequired,
  post: PropTypes.shape({
    athlete_id: PropTypes.number.isRequired,
    summary: PropTypes.string.isRequired
  }).isRequired,
  authorAvatarUrl: PropTypes.string.isRequired,
  authorDisplayName: PropTypes.string.isRequired
};

export default PostsKudosAndComments;
